import styled from 'styled-components';
import { IRadioGroup2Props } from '../../../types/formTypes';

export const Container = styled.div``;

export const RadioGroup = styled.div<Pick<IRadioGroup2Props, 'horizontalMode' | 'gap'>>`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: ${({ horizontalMode }) => {
    if (horizontalMode) return 'row';
    return 'column';
  }};
  gap: ${({ gap }) => `${gap}px`};
`;

export const ErrorLabel = styled.div<Pick<IRadioGroup2Props, 'darkMode'>>`
  margin-top: 20px;
  color: ${({ darkMode }) => {
    if (darkMode) return 'var(--base-color-white)';
    return 'var(--base-color-errorstate)';
  }};
`;
